/**
 * Pagination Class
 * 페이지네이션 처리
 */
export class Pagination {
    constructor() {
        this.isInitialized = false;
    }

    init() {
        if (this.isInitialized) return;
        
        // 전역 함수로 등록 (기존 코드와의 호환성)
        window.goListMove = (page) => {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('page', page);
            window.location.href = window.location.pathname + '?' + urlParams.toString();
        };
        
        this.isInitialized = true;
    }
}

